import { type SVGProps } from 'react'
import { cx } from 'src/utils/cx'
import MingcuteHeartFill from '~icons/mingcute/heart-fill'
import styles from './LikeHeart.module.css'

export function LikeHeart(
  props: SVGProps<SVGSVGElement> & { liked?: boolean },
) {
  const { liked, className, ...rest } = props

  return (
    <MingcuteHeartFill
      {...rest}
      data-liked={liked ? '' : null}
      className={cx(
        'text-zinc-400 data-[liked]:text-red-500 [--duration:100ms]',
        liked ? styles['animate-like'] : styles['animate-unlike'],
        className,
      )}
    />
  )
}
